import { useCallback } from 'react';
import { useScrollGroupContext } from './context.mjs';
"use strict";
function useScrollGroupSetScroll() {
  const {
    scrollGroupItemsRef
  } = useScrollGroupContext();
  const setScroll = useCallback((element, offset) => {
    if (offset.left !== void 0 && Math.floor(offset.left) !== Math.floor(element.scrollLeft)) {
      element.scrollLeft = offset.left;
    }
    if (offset.top !== void 0 && Math.floor(offset.top) !== Math.floor(element.scrollTop)) {
      element.scrollTop = offset.top;
    }
  }, []);
  return useCallback(offset => {
    scrollGroupItemsRef.current?.forEach(({
      refObject
    }) => {
      if (refObject?.current) {
        setScroll(refObject.current, offset);
      }
    });
  }, [scrollGroupItemsRef, setScroll]);
}
export { useScrollGroupSetScroll };
//# sourceMappingURL=useScrollGroupSetScroll.mjs.map
